import React from "react";
import Box from "@mui/joy/Box";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import { Card } from "@mui/joy";
import Divider from "@mui/joy/Divider";

export default function TerminosySeguridad() {
  let Header = () => {
    return (
      <Box>
        <AspectRatio
          variant="plain"
          ratio="1"
          sx={{
            width: "100px",
            marginBottom: "2rem",
            borderRadius: "12px",
          }}
        >
          <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
        </AspectRatio>
        <Typography level="h1">Estándares de Seguridad Infantil</Typography>
        <Box>
          <Typography>Email: contacto@amigoutdoors.com</Typography>
        </Box>
      </Box>
    );
  };

  let Body = () => {
    return (
      <Box
        sx={{
          display: "grid",
          gap: 1.5,
          maxHeight: "70vh",
          padding: 2,
        }}
      >
        <Divider />
        <Box>
          <Titulo x="Estándares de Seguridad Infantil – AmigOutdoors" />

          <Parrafo x="En AmigOutdoors, nos comprometemos a mantener una comunidad segura para todos los usuarios y a proteger especialmente a niños, niñas y adolescentes frente a cualquier tipo de explotación o abuso sexual." />
          <Parrafo x="Nuestra política prohíbe estrictamente el uso de la plataforma para compartir, solicitar o distribuir contenido sexual, material de abuso infantil o cualquier conducta que atente contra la integridad de menores de edad." />

          <Titulo x="Compromisos" />
          <Parrafo x="• Cumplimos con las leyes de protección infantil vigentes en Chile y otros países donde operamos." />
          <Parrafo x="• Actuamos de forma inmediata ante cualquier denuncia de contenido o comportamiento inapropiado." />
          <Parrafo x="• Cualquier caso sospechoso de abuso o explotación infantil será reportado de inmediato a las autoridades competentes." />
          <Parrafo x="• Todos los usuarios pueden reportar incidentes o preocupaciones escribiendo a: contacto@amigoutdoors.com" />

          <Titulo x="Autoridades de referencia en Chile" />
          <Parrafo x="• Policía de Investigaciones (PDI) — Brigada del Cibercrimen: https://www.pdichile.cl/" />
          <Parrafo x="• Fono Denuncia Segura: 600 400 0101" />

          <Parrafo x="Fecha de última actualización: Octubre 2025" />
        </Box>
        <Divider />
      </Box>
    );
  };
  let Titulo = ({ x }) => {
    return (
      <Typography level="h3" marginBottom={2} marginTop={1}>
        {x}
      </Typography>
    );
  };
  let Parrafo = ({ x }) => {
    return <Typography level={"body-md"}>{x}</Typography>;
  };

  let logo = `${process.env.REACT_APP_FRONTEND_URL}/uploads/logo.svg`;
  return (
    <Box
      flex={1}
      marginLeft={{ md: 40 }}
      marginRight={{ md: 40 }}
      marginTop={{ md: 10 }}
      marginBottom={{ md: 10 }}
    >
      <Card
        variant="soft"
        sx={{ minHeight: { md: "100vh", xs: "220vh" }, padding: { md: 6 } }}
      >
        <Header />
        <Body />
      </Card>
    </Box>
  );
}
